import { FocusableOption, FocusKeyManager } from '@angular/cdk/a11y';
import { Injectable, QueryList } from '@angular/core';

/**
 * @ngdoc service
 * @name ApFocusKeyManagerFactory
 *
 * @description
 */
@Injectable()
export class ApFocusKeyManagerFactory {
    /**
     * @ngdoc method
     * @name ApFocusKeyManagerFactory#create
     * @methodOf ApFocusKeyManagerFactory
     *
     * @param items
     *
     * @returns
     *
     * @description
     *
     *
     */
    create<T extends FocusableOption>(items: QueryList<T>): FocusKeyManager<T> {
        return new FocusKeyManager<T>(items);
    }
}
